<template>
  <div class="my-edit-bookshelf-area">
    <div class="my-shelfEdit">
      <div class="bookshelft-header-div"><span class="bookshelf-header">我的专辑</span><span style="margin-right:4px">></span><span class="bookshelf-header">编辑专辑</span></div>
      <setUpEdit ref="setupedit"></setUpEdit>
      <bookTransfer @getSeaveButton="getSeaveButton" ref="transfer"></bookTransfer>
      <shelfLibButton :showSaveButton="showSaveButton" @saveDataCon="saveDataCon" :setType="setType"></shelfLibButton>
    </div>
  </div>
</template>
<script>
import setUpEdit from '@components/editBookShlefLibrary/setUpEdit'
import bookTransfer from '@components/editBookShlefLibrary/bookTransfer'
import shelfLibButton from '@components/editBookShlefLibrary/shelfLibButton'
import BookShelfInterface from '@api/BookShelf'
import { setEncryption, sliceStrPicUrl } from '@/utils'

export default {
  name: 'shelfEdit',
  data() {
    return {
      setType: '专辑',
      showSaveButton: true
    }
  },
  components: {
    setUpEdit,
    bookTransfer,
    shelfLibButton
  },
  methods: {
    getSeaveButton(item) {
      this.showSaveButton = item
    },
    saveDataCon(type) {
      if (this.$store.state.config.bookShelfObj.title == '') {
        this.$message({
          message: '必须填写专辑名称',
          type: 'error'
        })
        return false
      }
      if (this.$store.state.config.bookShelfObj.selPoster == 1 && !this.$store.state.config.bookShelfObj.customTit) {
        this.$message({
          message: '请设置风格名称',
          type: 'error'
        })
        return
      }
      if (this.$refs.setupedit.switchNewsPaper == 1) {
        const relevanceText = this.$store.state.config.bookShelfObj.relevanceText

        let typeList = []
        this.rightBookList.forEach((v, i) => {
          if (v.category == undefined) {
            v.category = 2
          }
          typeList.push(v.category)
        })
        // 类型未无
        if (typeList.indexOf(2) !== -1) {
          this.$message({
            message: '请确保专辑内的刊物类型一致',
            type: 'error'
          })
          return false
        }
        let a = typeList.indexOf(0) == -1 && typeList.indexOf(1) !== -1
        let b = typeList.indexOf(1) == -1 && typeList.indexOf(0) !== -1
        let c = !(a || b)
        // 类型不全为0 类型不全为1
        // if (!(typeList.indexOf(0) == -1 && typeList.indexOf(1) !== -1) || (typeList.indexOf(1) == -1 && typeList.indexOf(0) !== -1)) {
        if (c) {
          this.$message({
            message: '请确保专辑内的刊物类型一致',
            type: 'error'
          })
          return false
        }

        // let listBookLink = []
        // this.bookLinkWorkAllList.forEach((v, i) => {
        //   listBookLink.push(v.id + '')
        // })

        // let ary = this.bookIds.split(',').concat(listBookLink)
        // let s = ary.join(',') + ','
        // for (let i = 0; i < ary.length; i++) {
        //   if (s.replace(ary[i] + ',', '').indexOf(ary[i] + ',') > -1) {
        //     this.$message({
        //       message: '保存失败，请移出刊物类型不同的书刊作品，或关闭快速切换报刊功能',
        //       type: 'error'
        //     })
        //     return false
        //   }
        // }

        if (relevanceText == '') {
          this.$message({
            message: '必须填写快速切换书刊关联名称',
            type: 'error'
          })
          return false
        } else if (relevanceText.length < 2) {
          this.$message({
            message: '快速切换报刊名称字数最少输入两个字'
          })
          return false
        }
      }

      const questionaireCheckReason = this.$refs.setupedit.check().questionaireCheckReason
      if (!questionaireCheckReason) {
        this.$message({ message: '请完成读者在线问卷设置', type: 'error' })
        return
      }

      const exp = /attach.*/g
      const cover = this.$store.state.config.bookShelfObj.cover ? this.$store.state.config.bookShelfObj.cover.match(exp)[0] : ''
      if (cover === '' && this.$store.state.config.bookShelfObj.coverOption === 1) {
        this.$message({ message: '请上传自定义专辑封面', type: 'error' })
        return
      }

      let logo = null
      if (this.$refs.setupedit.logo == 0) {
        logo = 'logo.png'
      } else if (this.$refs.setupedit.logo == 1) {
        let shelfLogo = this.$store.state.config.bookShelfLogo.logo
        if (shelfLogo) {
          logo = shelfLogo.substring(shelfLogo.indexOf('attach/'))
        }
      }
      let thumbnail = this.$store.state.config.bookShelfObj.thumbnail == 'default' ? '' : this.$store.state.config.bookShelfObj.thumbnail
      const payload = this.$store.state.config.bookShelfObj.selPoster == 1 ? this.$store.state.config.bookShelfObj.cusImg : 'poster.png'
      const posterPic = sliceStrPicUrl(payload)
      const questionaireData = this.$refs.setupedit.getData().questionaireData

      let chargeIcon = this.$store.state.config.bookShelfObj.chargeIcon
      let chargeIconType = this.$store.state.config.bookObj.chargeIconType
      if (chargeIconType !== -1) {
        chargeIcon = chargeIconType
      } else if (chargeIcon && chargeIcon.length && chargeIcon.length > 0) {
        chargeIcon = chargeIcon.substring(chargeIcon.indexOf('attach/'))
      }

      let params = {
        id: this.albumId,
        style: this.$store.state.config.bookShelfObj.style,
        openMode: this.$store.state.config.bookShelfObj.openMode,
        name: this.$store.state.config.bookShelfObj.title,
        adornment: this.$refs.setupedit.adornment ? this.$refs.setupedit.adornment.substring(this.$refs.setupedit.adornment.indexOf('attach/')) : '',
        shareTitle: this.$store.state.config.bookShelfObj.shareTitle,
        description: this.$store.state.config.bookShelfObj.shareDesc,
        thumbnail: thumbnail.indexOf('data:image') > -1 ? thumbnail : '',
        bookIds: this.bookIds,
        logo: logo,
        url: this.$refs.setupedit.url,
        linkJump: this.$refs.setupedit.linkJump,
        poster: this.$store.state.config.bookShelfObj.isPoster,
        posterStyle: this.$store.state.config.bookShelfObj.selPoster,
        posterTitle: this.$store.state.config.bookShelfObj.selPoster == 0 ? '' : this.$store.state.config.bookShelfObj.customTit,
        posterPic: posterPic,
        posterQrCodeShow: this.posterAlbum.posterQrCodeShow,
        posterNameShow: this.posterAlbum.posterNameShow,
        posterName: this.posterAlbum.posterName,
        posterTextShow: this.posterAlbum.posterTextShow,
        posterPromptText: this.posterAlbum.posterPromptText,
        posterCover: this.posterAlbum.posterCover.toString(),
        cover: cover,
        coverOption: this.$store.state.config.bookShelfObj.coverOption,
        switchNewsPaper: this.$refs.setupedit.switchNewsPaper,
        associationName: this.$refs.setupedit.switchNewsPaper ? this.$store.state.config.bookShelfObj.relevanceText : '',
        charge: this.$store.state.config.bookShelfObj.charge,
        switchGroup: JSON.stringify(this.$store.state.config.bookShelfObj.displayOrNot),
        language: this.$store.state.config.bookShelfObj.language,
        ...questionaireData
      }
      BookShelfInterface.BookShelfEdit(params).then((res) => {
        if (res.data.code == 0 && res.data.data) {
          this.$store.commit('config/UPDATE_BOOKSHELFTITLE_MESSAGE', '')
          this.$store.commit('config/UPDATE_BOOKSHELFTITLE_TITLE', '')
          this.$store.commit('config/UPDATE_BOOKSHELFTITLE_DESC', '')
          this.$store.commit('config/UPDATE_BOOKSHELFTHUMBNAIL', '')
          this.$store.commit('config/UPDATE_BOOKSHELF_BOOKIDS', [])
          this.$store.commit('config/UPDATE_BOOKSHELFRELEVANCETEXT', '')
          const encryption_id = setEncryption(this.albumId)
          if (type == 'goDetail') {
            this.$router.push({ path: '/bookshelfdetail', query: { id: encryption_id, openMode: this.$store.state.config.bookShelfObj.openMode } })
          } else if (type == 'goList') {
            let componentManager = 'Published'
            this.$store.commit('manage/UPDATE_COMPONENTMANAGER', componentManager)
          }
        } else if (res.data.code == 1) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    }
  },
  computed: {
    rightBookList() {
      return this.$store.state.config.rightBookList
    },
    bookLinkWorkAllList() {
      return this.$store.state.config.bookLinkWorkAllList
    },
    bookIds() {
      return this.$store.state.config.bookShelfObj.bookIds.toString()
    },
    albumId() {
      return window.sessionStorage.getItem('albumId')
    },
    posterAlbum() {
      return this.$store.state.config.poster.album
    }
  },
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'overflow:auto')
  },
  destroyed() {
    // document.querySelector('body').setAttribute('style', 'overflow:hidden')
  }
}
</script>
<style scoped lang="scss">
.my-edit-bookshelf-area {
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
  overflow-y: auto;
  .my-shelfEdit {
    width: 1140px;
    margin: 0 auto;
    margin-left: 50px;
    position: relative;
    .bookshelft-header-div {
      padding: 8px 0;
      .bookshelf-header {
        font-size: 17px;
        margin-right: 6px;
        color: #000;
        font-weight: 400;
      }
      .num-info {
        font-size: 16px;
        display: inline-block;
      }
    }
  }
  /deep/ .shelfEditButton {
    position: fixed;
    bottom: 0;
    height: 80px;
    width: 1140px;
    background-color: #fff;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #ececec;
    z-index: 999;
    .goDetail {
      width: 133px;
      background: #df5813;
      color: #fff;
      font-size: 14px;
    }
    .goList {
      border: 1px solid #df5813;
      color: #df5813;
      font-size: 14px;
    }
  }
}
</style>
